/**
 * Created by Christiaan on 01/03/2017.
 */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef, EventEmitter, HostListener, Output,
    ViewChild
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import {GlobalAlertService} from '../../global-alert.service';
import {ButtonCode, ButtonInterface, GlobalPopup} from '../../global-popup';
import {TranslateService} from '../../../../shared/services/translate/translate.service';
import {
    TableOptions,
    TableOptionsField,
    TableOptionsSet
} from '../../../../shared/components/table/tableColumnSelector/table-options';
import {AuthorizationService} from '../../../../shared/services/authorization/authorization.service';
import {TableOptionsService} from '../../../../shared/components/table/table-options.service';
import {GlobalModel} from '../../../../shared/services/state/global.model';
import {TreeMapFormComponent} from '../../../../shared/components/tree-map-form/tree-map-form.component';
import {RequestFailure} from '../../../../shared/services/http/request-failure';
import {AbstractBasePopupComponent} from '../abstract-base-popup.component';
import {TooltipService} from '../../../../shared/services/tooltip/tooltip.service';
import {TableColumnSelectorComponent} from '../../../../shared/components/table/tableColumnSelector/tableColumnSelector.component';
import {TableSortDirection} from '../../../../shared/components/table/shared/baseTable/baseTable.interface';
import {PopupDisplayMode} from '../default-popup-wrapper/default-popup-wrapper.interface';
import {LumiSelectOption} from '../../../../shared/components/commonUI/select/lumi-select/lumi-select.interface';
import {LoggerService} from "../../../../shared/services/logger/logger.service";
import {ITableTab} from "../../../../shared/components/table/tableTabs/tableTabs.interface";
import Utils from "../../../../shared/utils/utils";
import {GlobalEvent} from "../../../../shared/interfaces/global-event";
import {MechanicFilter} from "../../../../modules/mechanic/mechanic/mechanic.interface";

@Component({
    selector: 'global-popup-table-options-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'global-popup-table-options.component.html',
    styleUrls: ['global-popup-table-options.component.scss']
})
export class GlobalPopupTableOptionsComponent extends AbstractBasePopupComponent implements AfterViewInit {
    @ViewChild('columnSelectorComponent', {static: false}) columnSelector: TableColumnSelectorComponent;
    @ViewChild('dragContainer', {static: false}) dragContainer: ElementRef<HTMLDivElement>;
    
    public tableOptionSets: TableOptionsSet[] = [];
    public tableOptionSetsChanges: ITableTab[] = [];
    public selectedOptionsSetId: number = -1;
    public loadingSet: boolean = false;
    public hideMap: boolean = false;
    public activeSmartSelectionName: string = null;
    public POPUP_DISPLAY_MODE = PopupDisplayMode;
    public buttonSaveSelectionDisabled: boolean = true;
    
    public tableFields: TableOptionsField[] = [];
    public tempShowArchived: boolean = false;
    private tableOptions: TableOptions;
    private currentModulePath: string = '';

    private isDirty:boolean = false;
    private hasMadeChanges:boolean = false;
    private userClick:boolean = false;



    public constructor(
        protected cd: ChangeDetectorRef,
        protected globalAlertService: GlobalAlertService,
        protected elementRef: ElementRef,
        public ts: TranslateService,
        private model: GlobalModel,
        public auth: AuthorizationService,
        private tableOptionService: TableOptionsService,
        protected tooltipService: TooltipService,
        protected logger:LoggerService,
    ) {
        super(cd, globalAlertService, elementRef, ts, tooltipService, logger);
    }

    ngAfterViewInit() {
        this.currentModulePath = TreeMapFormComponent.moduleNameToPath(this.model.currentModule.value);

        // Get data send with the creation of the popup
        this.tableOptions = this.globalPopup.data.tableOptions;
        this.tableFields = this.tableOptions.tableFields;
        this.hideMap = this.globalPopup.data.hideMap;
        
        this.getOptionSets();
        this.initForm(this.tableOptions);
        this.cd.detectChanges();
    }

    public changePopupButtonState(disabled:boolean):void {
        this.buttonSaveSelectionDisabled = disabled
        // this.globalPopup.buttonArray.find(_x => {
        //     return _x.code == ButtonCode.SAVE;
        // }).disabled = disabled;
        // this.model.onGlobalEvent.next(new GlobalEvent(GlobalEvent.EVENT_TIGGER_CHANGE_DETECTION, {}));
    }

    public onRankChange(event: CdkDragDrop<any[]>) {
        //Move the array
        moveItemInArray(this.tableOptionSets, event.previousIndex, event.currentIndex);
        //Remove the -1 id that is added programmatically.
        this.tableOptionSetsChanges = this.tableOptionSets
            .map(item => ({ ...item })) as ITableTab[];

        //Update rank for each item
        this.tableOptionSetsChanges.map((item, index) => {
            item.rank = index + 1;
        });

        this.handleRankSave();
    }

    //Save the order
    private handleRankSave():void{
        if(this.tableOptionSetsChanges.length > 0){
            this.tableOptionService.updateList(
                this.currentModulePath,
                this.tableOptionSetsChanges,
                (response: any) => {
                    // Get the list, with new name
                    if (response) {
                        this.tableOptionSetsChanges = [];
                        this.getOptionSets(this.selectedOptionsSetId);
                        this.cd.detectChanges();
                    }
                }, () => {
                }, () => {
                }
            );
        }
    }

    public toggleItemOnTab(item:TableOptionsSet,$event: MouseEvent):void{
        this.preventDefault($event);
        this.tableOptionService.updateTableOptionSet(
            this.currentModulePath,
            Number(item.id),
            item.name,
            !item.showAsTab,
            item.isGlobal,
            null,
            (response: any) => {
                // Get the list, with new name
                if (response) {
                    this.tableOptionSetsChanges = [];
                    this.getOptionSets();
                    this.cd.detectChanges();
                }
            }
        );
    }

    public toggleItemGlobal(item:TableOptionsSet,$event: MouseEvent):void{
        this.preventDefault($event);
        this.tableOptionService.updateTableOptionSet(
            this.currentModulePath,
            Number(item.id),
            item.name,
            item.showAsTab,
            !item.isGlobal,
            null,
            (response: any) => {
                // Get the list, with new name
                if (response) {
                    this.tableOptionSetsChanges = [];
                    this.getOptionSets();
                    this.cd.detectChanges();
                }
            }
        );
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;
        if (!clickedElement.closest('.smart-selection-dropdown')) {
            this.closeAllOptionDropdowns();
        }
        this.setUserClick();
    }

    public setUserClick():void{
        this.userClick = true;
    }

    public toggleOptionsDropdown(item:TableOptionsSet,$event: MouseEvent):void{
        // Prevent default event
        this.preventDefault($event);
        // Close all other dropdowns
        this.closeAllOtherOptionDropdowns(item);
        // Toggle dropdown
        item.showOptionsDropdown = !item.showOptionsDropdown;
    }

    public canEditTab(item:TableOptionsSet):boolean{
        return item ? (this.auth.allowGlobalTab() ? true : (!item.isGlobal)) : false;
    }

    public closeAllOptionDropdowns():void{
        this.tableOptionSets.forEach(_x => {
            _x.showOptionsDropdown = false;
        })
    }
    public closeAllOtherOptionDropdowns(item:TableOptionsSet):void{
        this.tableOptionSets.forEach(_x => {
            if(_x !== item){
                _x.showOptionsDropdown = false;
            }
        })
    }

    public preventDefault($event: MouseEvent): void {
        Utils.preventDefault($event);
    }

    // Select option set from the dropdown
    public handleSelectOptionSet(selectedOptionId: number|string): void {
        this.closeAllOptionDropdowns();
        // Change selected set, and do the call
        this.selectedOptionsSetId = Number(selectedOptionId);
        this.activeSmartSelectionName = null;
        if (this.selectedOptionsSetId !== -1) {
            const smartSelection = this.tableOptionSets.find(set => set.id === this.selectedOptionsSetId);
            this.activeSmartSelectionName = smartSelection.name;

            //Instantly change tab on background. Move to closePopup to trigger only when popup closes
            this.model.selectedTabId.next(Number(this.selectedOptionsSetId));
            this.madeChanges();
        }
        this.model.changedSmartSelection.next(false);

        //Disable save button
        this.changePopupButtonState(true);
        this.getOptionSet();
    }

    private madeChanges():void{
        this.hasMadeChanges = true;
    }


    // Option set list call
    private getOptionSets(autoSelectId: number = -1, addNew:boolean = false): void {
        this.activeSmartSelectionName = null;
        this.loadingSet = true;
        this.tableOptionSets = [];
        this.tableOptionService.listTableOptionSets(this.currentModulePath, (json: ITableTab[]) => {

            this.loadingSet = false;
            if (!json) {
                this.logger.log('[GlobalPopupTableOptionsComponent] ' + 'No valid options, exit');
                return;
            }

            this.tableOptionSets = json;

            //Make sure the options are pushed to the tableOptionsSets. The table tabs use this.
            this.model.tableOptionsSets.next(json);

            if(this.model.selectedTabId.value > -1 && !addNew) {
                autoSelectId = this.model.selectedTabId.value;
            }


            if (this.tableOptionSets.length > 0) {
                if(this.model.selectedTabId.value !== -2){
                    if (autoSelectId > -1) {
                        this.selectedOptionsSetId = autoSelectId;
                        this.activeSmartSelectionName = this.tableOptionSets.find(set => set.id === this.selectedOptionsSetId)?.name;
                    } else if (this.globalPopup.data
                        && this.globalPopup.data.selectedScheme > 0
                        && this.getOptionSetById(this.globalPopup.data.selectedTableOptionSet)
                    ) {
                        this.selectedOptionsSetId = this.globalPopup.data.selectedTableOptionSet;
                        this.globalPopup.data.selectedTableOptionSet = -1;
                    } else {
                        this.selectedOptionsSetId = Number(this.tableOptionSets[0].id);
                    }
                    // Get the selected option set
                    this.getOptionSet();
                } else {
                    this.isDirty = false;
                    this.cd.detectChanges();
                }

            } else {
                //Make sure object type observable is triggered when no tabs are available
                this.model.selectedOptionTypes.next(this.model.availableOptionTypes.value)
            }
            this.isDirty = false;

            this.scrollToActiveElement();


        }, () => {
        }, () => {
        });
    }


    
    public handleRenameOptionSet(item:TableOptionsSet,$event: MouseEvent): void {
        this.preventDefault($event);
        let selectedOptionSet: any = item;
        if (selectedOptionSet) {
            this.globalAlertService.addPopupInput(
                this.ts.translate('optionset.renametitle'),
                this.ts.translate('optionset.renamelabel',
                    [selectedOptionSet.name]),
                selectedOptionSet.name,
                [{
                    label: this.ts.translate('Annuleren'),
                    code: ButtonCode.ANNULEREN,
                    isPrimary: false
                }, {
                    label: this.ts.translate('Ok'), code: ButtonCode.OK,
                    callback: (code: string, data: any) => {
                        // TODO: meer naam-validatie?
                        let newName: string = data.input;
                        newName = newName.trim();
                        
                        this.tableOptionService.updateTableOptionSet(
                            this.currentModulePath,
                            selectedOptionSet.id,
                            newName,
                            selectedOptionSet.showAsTab,
                            null,
                            null,
                            (response: any) => {
                                // Get the list, with new name
                                if (response) {
                                    this.tableOptionSetsChanges = [];
                                    this.getOptionSets();
                                    this.cd.detectChanges();
                                }
                            }
                        );
                        
                    }, isPrimary: true
                }], () => {
                });
        }
        
    }
    
    public handleDeleteOptionSet(item:TableOptionsSet,$event: MouseEvent): void {
        this.preventDefault($event);
        let selectedOptionSet: any = item;
        
        if (selectedOptionSet) {
            this.globalAlertService.addPopup(
                this.ts.translate('optionset.removetitle'),
                this.ts.translate('optionset.remove',
                    [selectedOptionSet.name]),
                [{
                    label: this.ts.translate('Annuleren'),
                    code: ButtonCode.ANNULEREN,
                    isPrimary: false
                }, {
                    label: this.ts.translate('Verwijderen'), code: 'DELETE',
                    callback: () => {
                        this.tableOptionService.deleteTableOptionSet(this.currentModulePath, selectedOptionSet.id, (json: any) => {
                                // delete success, reload option sets
                                this.getOptionSets();
                                this.model.changedSmartSelection.next(false);
                            },
                            (failure: RequestFailure) => {
                                this.globalAlertService.addPopup(this.ts.translate('Waarschuwing'), failure.message, [{
                                    label: this.ts.translate('Ok'),
                                    code: 'OK',
                                    isPrimary: true
                                }], () => {
                                });
                            },
                            () => {
                            });
                        
                    }, isPrimary: true
                }], () => {
                });
        }
    }
    
    public handleChangeArchived(): void {
        this.setUserClick();
        this.onColumnChange();
        this.model.changedSmartSelection.next(true);
        // Toggle archived button state
        this.tempShowArchived = !this.tempShowArchived;
    }
    
    // Return true is the current table options are displayed (so no specific option set)
    public isCurrentTableOptions(): boolean {
        return this.selectedOptionsSetId < 0;
    }
    
    public handlePopupAction(event: MouseEvent, alert: GlobalPopup, button: any): void {
        if (button.code === ButtonCode.SAVE) {
            this.applyFilterWithoutSave();
        } else if (button.code === ButtonCode.RESET) {
            this.globalAlertService.addPopup(this.ts.translate('filter.resettitle'), this.ts.translate('filter.resetfull'),
                [{
                    label: this.ts.translate('Annuleren'),
                    code: ButtonCode.ANNULEREN,
                    isPrimary: false
                },
                    {
                        label: this.ts.translate('Doorgaan'), code: 'RESET',
                        callback: () => {
                            this.logger.log('[GlobalPopupTableOptionsComponent] ' + 'RESET all fields');
                            this.getOptionSet();
                            this.isDirty = false;
                            this.changePopupButtonState(true);
                        }, isPrimary: true
                    }], () => {
                }
            );
        } else {
            if(this.selectedOptionsSetId !== -2){
                if(this.isDirty){
                    this.globalAlertService.addPopup(this.ts.translate('filter.closewarning-title'), this.ts.translate('filter.closewarning-content'),
                        [{
                            label: this.ts.translate('Annuleren'),
                            code: ButtonCode.ANNULEREN,
                            isPrimary: false
                        },
                            {
                                label: this.ts.translate('close'), code: 'CLOSE',
                                callback: () => {
                                    // Cancel and other

                                    this.model.changedSmartSelection.next(false);
                                    this.onPopupAction.emit({event: event, alert: alert, button: button});
                                }, isPrimary: true
                            }], () => {
                        }
                    );
                } else {
                    if(this.hasMadeChanges){
                        this.model.onGlobalEvent.next(new GlobalEvent(GlobalEvent.EVENT_CLOSE_FILTER_POPUP, {tableTabId: this.selectedOptionsSetId}));
                    }
                    this.model.changedSmartSelection.next(false);
                    this.onPopupAction.emit({event: event, alert: alert, button: button});
                }
            } else {
                this.model.changedSmartSelection.next(false);
                this.onPopupAction.emit({event: event, alert: alert, button: button});
            }
        }
    }

    public saveCurrentFilter():void{
        if (!this.isCurrentTableOptions()) {
            this.handleEditOptionSet(this.selectedOptionsSetId,null);
        }
    }

    public applyFilterWithoutSave(){
        let newTableOptions: TableOptions = {
            tableFields: this.columnSelector.getResultingTableFields(),
            showArchived: this.tempShowArchived,
        };

        //-1 is reserved for no tabs so use -2 instead
        this.selectedOptionsSetId = -2;

        this.model.onGlobalEvent.next(new GlobalEvent(GlobalEvent.EVENT_CLOSE_FILTER_POPUP, {tableTabId: this.selectedOptionsSetId, tableOptions:newTableOptions}));
        this.closePopup(null);
    }
    
    public closePopup(event: any): void {
        this.doDefaultCloseHandling(event, false);
    }
    
    public onColumnChange(): void {
        this.isDirty = true;
        this.model.changedSmartSelection.next(true);
        if(this.canEditTab(this.getOptionSetById(this.selectedOptionsSetId)) && this.userClick){
            this.changePopupButtonState(false);
        } else {
            this.changePopupButtonState(true);
        }
    }
    
    private initForm(tableOptions: TableOptions): void {
        this.tableFields = [...tableOptions.tableFields];
        this.tempShowArchived = tableOptions.showArchived;
    }
    
    // Get local option set by id
    private getOptionSetById(schemeId: number): TableOptionsSet {
        if(schemeId == -1){
            return null;
        } else {
            for (let i: number = 0; i < this.tableOptionSets.length; i++) {
                if (this.tableOptionSets[i].id === schemeId) {
                    return this.tableOptionSets[i];
                }
            }
        }

        return null;
    }
    
    private getOptionSet(): void {
        // Skip when loading 'custom' set
        if (this.isCurrentTableOptions()) {

            // Re-init the form with the original values
            this.initForm(this.tableOptions);
            this.cd.detectChanges();
            
            return;
        }
        this.loadingSet = true;
        this.cd.detectChanges();
        
        this.tableOptionService.getTableOptionSet(this.currentModulePath, this.selectedOptionsSetId, (json: any) => {
            
            this.loadingSet = false;
            
            // Merge the table options. Current table options should be leading. They might contain new columns ect
            // Don't change the this.tableOptions, keep the original
            let newTableOptions: any = {
                tableFields: JSON.parse(JSON.stringify(this.tableFields)),
                showArchived: this.tempShowArchived
            };

            this.tableOptionService.mergeTableOptions(newTableOptions, json.data.tableOptions);
            this.initForm(newTableOptions);

            if(json.data && json.data.objectTypes){
                this.model.selectedOptionTypes.next(json.data.objectTypes);
            }  else {
                this.model.selectedOptionTypes.next(this.model.availableOptionTypes.value);
            }
            
            this.cd.detectChanges();
        }, () => {
            this.loadingSet = false;
            this.cd.detectChanges();
        }, () => {
        });
    }
    
    public handleAddOptionSet(): void {
        this.globalAlertService.addPopupInput(
            this.ts.translate('optionset.createtitle'),
            this.ts.translate('optionset.createlabel'),
            '',
            [{
                label: this.ts.translate('Annuleren'),
                code: ButtonCode.ANNULEREN,
                isPrimary: false
            },
                {
                    label: this.ts.translate('Ok'), code: ButtonCode.OK,
                    callback: (code: string, data: any) => {

                        let newTableOptions: any = {
                            tableFields: this.columnSelector.getResultingTableFields(),
                            showArchived: this.tempShowArchived,
                        };

                        // TODO: meer naam-validatie?
                        let newName: string = data.input;
                        newName = newName.trim();

                        this.tableOptionService.createTableOptionSet(
                            this.currentModulePath,
                            newName,
                            {
                                tableOptions: newTableOptions,
                                objectTypes: this.model.selectedOptionTypes.value
                            },
                            (response: any) => {
                                if (response) {
                                    this.getOptionSets(response.id, true);
                                    this.model.changedSmartSelection.next(false);
                                    this.changePopupButtonState(true);
                                    this.cd.detectChanges();
                                }
                            }, () => {
                            }, () => {
                            }
                        );
                    }, isPrimary: true
                }], () => {
            });
    }
    
    // Save the data, not the name per se
    public handleEditOptionSet(optionId:number|string,$event: MouseEvent): void {
        this.preventDefault($event);
        let selectedOptionSet: any = this.getOptionSetById(Number(optionId));
        if (selectedOptionSet) {
            this.globalAlertService.addPopup(
                this.ts.translate('optionset.savetitle'),
                this.ts.translate('optionset.savelabel',
                    [selectedOptionSet.name]),
                [{
                    label: this.ts.translate('Annuleren'),
                    code: ButtonCode.ANNULEREN,
                    isPrimary: false
                }, {
                    label: this.ts.translate('Doorgaan'), code: 'SAVE',
                    callback: () => {
                        let newTableOptions: TableOptions = {
                            tableFields: this.columnSelector.getResultingTableFields(),
                            showArchived: this.tempShowArchived
                        };


                        this.setMapTableFilterActive(selectedOptionSet);
                        
                        this.tableOptionService.updateTableOptionSet(
                            this.currentModulePath,
                            selectedOptionSet.id,
                            selectedOptionSet.name,
                            selectedOptionSet.showAsTab,
                            selectedOptionSet.isGlobal,
                            {
                                tableOptions: newTableOptions,
                                objectTypes: this.model.selectedOptionTypes.value
                            },
                            (response: any) => {
                                // Refresh the option set so that a set with no columns will be displayed as the default selection
                                if (response) {
                                    this.handleSelectOptionSet(optionId)
                                    this.isDirty = false;
                                    this.madeChanges();
                                }
                            }
                        );
                        
                    }, isPrimary: true
                }], () => {
                });
        }
    }

    private setMapTableFilterActive(tableOptionsSet: TableOptionsSet):void{
        this.tableOptionSets.forEach(_x => {_x.active = false;});
        tableOptionsSet.active = true;
    }


    private scrollToActiveElement() {
        const activeElement = this.dragContainer.nativeElement.querySelector('.active') as HTMLElement;
        if (activeElement) {
            activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    
    private buildNewTableOptions(tableOptions: TableOptions): void {
        const newTableFields = this.columnSelector.getResultingTableFields();
        if (!newTableFields.some(field => field.visible)) {
            this.resetToDefaults(newTableFields);
        }
        tableOptions.tableFields = newTableFields;
        tableOptions.showArchived = this.tempShowArchived;
    }
    
    private resetToDefaults(tableFields: TableOptionsField[]): TableOptionsField[] {
        this.tempShowArchived = false;
        
        let rankCounter = 1;
        tableFields.forEach((field: any) => {
            field.visible = field.default;
            field.inMouseOver = field.default;
            field.sorting = false;
            field.sortingDirection = TableSortDirection.SORT_DIRECTION_UNSET;
            field.columnRank = field.visible ? rankCounter : null;
            field.filter = null;
            
            if (field.visible) {
                rankCounter++;
            }
        });
        const firstVisibleTableField = tableFields.filter(field => field.visible)[0];
        firstVisibleTableField.sortDirection = TableSortDirection.SORT_DIRECTION_ASC;
        firstVisibleTableField.sorting = true;

        return tableFields;
    }

}
